import loadable from '@loadable/component'
import { Container } from '@uswitch/ev-core/react'
import React, { Fragment } from 'react'

// eg. https://github.com/uswitch/fs-core/blob/main/src/components/compounds/component.tsx

const COMPONENTS = {
  'switch-in-three-steps': loadable(() => import('./switch-in-three-steps')),
  'deal-table': loadable(() => import('./deal-table')),
  'author-updated-module': loadable(() => import('./author-updated-module')),
  'speed-table': loadable(() => import('./speed-table'))
}

const Component = (props) => {
  const componentType = props.options?.component || props.component
  const C = COMPONENTS[componentType] || Fragment
  const options = props.options
  const container = props.container

  return (
    <Choose>
      <When condition={container}>
        <Container>
          <C options={options} {...props} />
        </Container>
      </When>
      <Otherwise>
        <C options={options} {...props} />
      </Otherwise>
    </Choose>
  )
}

const component = {
  variations: {
    default: Component
  },
  wrapperConfig: { useContainer: false }
}

export default component
